import { render, staticRenderFns } from "./PaDeptRevenue.vue?vue&type=template&id=751c1942&scoped=true"
import script from "./PaDeptRevenue.vue?vue&type=script&lang=js"
export * from "./PaDeptRevenue.vue?vue&type=script&lang=js"
import style0 from "./PaDeptRevenue.vue?vue&type=style&index=0&id=751c1942&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751c1942",
  null
  
)

export default component.exports